import { Organization } from "./organization"
import { Role } from "./role"

export class User {
    public id = 0
    public firstname = ''
    public lastname = ''
    public email = ''
    public phone = ''
    public username = ''
    public password = ''
    public password_hashed = ''
    public password_visible = ''
    public role: Role = new Role;
    public organization: Organization = new Organization
    public closed = false
    public ai = false

    constructor() {}
}